/**
 * Scene component extracted from SlotMachineScene
 */

class SlotMachineSceneComponent extends ScriptComponent {
    onCreate() {
        const mission = (PrefabBuilder.resolveProperty(this.options.args, this.context) || [])[0];
        this.slotMachine = mission.logic;
    }

    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);

        this.sceneComponent.setStyling({
            bundle: "slot_machine_bg",
            backgroundId: "background"
        });
        this.sceneComponent.setAudioStyles({
            res: bundles.slot_machine.urls.music,
            delay: 1.0
        });
        this.sceneComponent.setBundles(["slot_machine", "slot_machine_bg"]);
    }

    onSceneLoaded() {
        PseudoRandom.GET().randomSeed();

        this.slotMachineContainer = new cc.Node();
        this.slotMachineContainer.addChild(new SlotMachineButton(this.slotMachine.slotMachine));
        this.slotMachineContainer.addChild(new SlotMachineView(this.slotMachine.slotMachine));
        this.node.background.addChild(this.slotMachineContainer);

        this.updateContainerPosition();
    }

    onReady() {
        this.onResize();
    }

    updateContainerPosition() {
        this.slotMachineContainer.setAlignment(this.node.background.width / 2, this.node.background.height / 2);
    }

    onResize() {
        this.updateContainerPosition();
    }

    onDestruct() {
        this.slotMachine.slotMachine.purge();
    }
}

Prefab.registerComponent("SlotMachineSceneComponent", SlotMachineSceneComponent);
